function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import styled from 'styled-components';
import { typography, border, buttonStyle } from 'styled-system';
import ssPropTypes from '@styled-system/prop-types';
import { themed } from '../utils/system';
import { Box } from '../index';
var LegacyButton = styled(Box)(themed('Button'), typography, border, buttonStyle // rebass moved theme here TODO: why?
// themed('Button'),
);
LegacyButton.propTypes = _extends({}, ssPropTypes.typography, ssPropTypes.border, ssPropTypes.buttonStyle);
LegacyButton.defaultProps = {
  as: 'button'
};
LegacyButton.displayName = 'Button';
export default LegacyButton;